import { DISTRICT_LIST, DISTRICT_CHANGE_STATUS, DISTRICT_ADDEDIT, DISTRICT_WOP_LIST, DISTRICT_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const DistrictListApi = (payload) => {
    return apiInstance.post(DISTRICT_LIST, payload, {
        headers: authHeader(),
    });
};

export const districtChangeStatusApi = (payload) => {
    return apiInstance.post(DISTRICT_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditDistrictApi = (payload) => {
    return apiInstance.post(DISTRICT_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const districtDeleteApi = (payload) => {
    return apiInstance.post(DISTRICT_DELETE, payload, {
        headers: authHeader(),
    });
};

export const districtWopListApi = (payload) => {
    return apiInstance.get(DISTRICT_WOP_LIST, {
        headers: authHeader(),
        params: payload
    });
};  